import React from 'react';
import * as styles from '../ClickableCell/ClickableCell.scss';

interface Props {
  id: string;
  isClickable: boolean;
  title?: string;
  displayText: string;
  clickHandler?: Function;
}

class ClickableCell extends React.Component<Props> {

  render() {
    return (
      <div
        id={this.props.id}
        title={this.props.title ? this.props.title : undefined}
        className={this.props.isClickable ? styles.clickableElement : ''}
        onClick={() => {
          if (this.props.clickHandler) {
            this.props.clickHandler();
          }
        }}
      >
      {this.props.displayText}
      </div>
    );
  }
}

export default ClickableCell;
